import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import { useTheme } from "../../providers/theme-provider";
import { useTranslation } from "react-i18next";

const AccordionItem = ({ title, content, isOpen, onClick }) => {
  const { colors } = useTheme();

  return (
    <div className="border-b border-gray-200">
      <button
        className="flex w-full items-center justify-between py-4 text-left"
        onClick={onClick}
      >
        <span
          className="font-semibold"
          style={{
            fontSize: fontSizes.body,
            color: colors.mainHeading,
          }}
        >
          {title}
        </span>
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <img src={assetIcons.add} alt="" className="w-4" />
        </motion.div>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div
              className="xl:pb-4"
              style={{
                fontSize: fontSizes.statNumber,
                color: colors.mainText,
              }}
            >
              {content}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default function Accordion() {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  const items = [
    {
      title: t("accordian.title1"),
      content: t("accordian.description1"),
    },

    {
      title: t("accordian.title2"),
      content: t("accordian.description2"),
    },
  ];

  return (
    <div className="w-full max-w-2xl">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isOpen={openIndex === index}
          onClick={() => setOpenIndex(openIndex === index ? null : index)}
        />
      ))}
    </div>
  );
}
